// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fms-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2px 0 1px;
  font-size: 14px;
  z-index: 9;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.fms-footer table {
  width: 100%;
  border-collapse: collapse;
}
.fms-footer .dateTimeSection {
  width: 100px;
}
.fms-footer .activityCounterSection {
  width: 130px;
}
.fms-footer .activityCounterSection a {
  margin: 0 4px;
}
.fms-footer .toggleConsole,
.fms-footer .toggleMiniMaps,
.fms-footer .toggleSidebar {
  width: 30px;
}
.fms-footer td {
  padding: 4px;
  border-left: 1px solid transparent;
  vertical-align: top;
  width: 1%;
  white-space: nowrap;
}
.fms-footer .languageSection {
  padding: 0;
}
.fms-footer a {
  color: #fff;
  line-height: 1;
}
.fms-footer a.active, .fms-footer a:hover {
  opacity: 1;
}
.fms-footer .languageSection {
  text-align: right;
}
.fms-footer svg {
  min-width: 17px;
  min-height: 17px;
}

@media (max-width: 959px) {
  .fms-footer .activityCounterSection {
    width: auto;
  }
}
@media (max-width: 499px) {
  .toggleConsole,
  .toggleMiniMaps,
  .toggleSidebar {
    display: none;
  }
  .fms-footer {
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Footer/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EAGA,eC6EgB;ED5EhB,UAAA;EACA,wCAAA;AAHD;AAIC;EACC,WAAA;EACA,yBAAA;AAFF;AAIC;EACC,YAAA;AAFF;AAIC;EACC,YAAA;AAFF;AAGE;EACC,aAAA;AADH;AAIC;;;EAGC,WAAA;AAFF;AAIC;EACC,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAFF;AAIC;EACC,UAAA;AAFF;AAIC;EACC,WAAA;EAEA,cAAA;AAHF;AAIE;EAEC,UAAA;AAHH;AAMC;EACC,iBAAA;AAJF;AAMC;EACC,eC2BiB;ED1BjB,gBC0BiB;AD9BnB;;AAUA;EAEE;IACC,WAAA;EARD;AACF;AAWA;EACC;;;IAGC,aAAA;EATA;EAWD;IACC,mBAAA;EATA;AACF","sourcesContent":["@import './../../assets/variables';\n\n.fms-footer {\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tpadding: 2px 0 1px;\n\t//background: $footerBackground;\n\t//color: #5f5f5f;\n\tfont-size: $footerFontSize;\n\tz-index: 9;\n\tborder-top: 1px solid rgba(#000000, 0.1);\n\ttable {\n\t\twidth: 100%;\n\t\tborder-collapse: collapse;\n\t}\n\t.dateTimeSection {\n\t\twidth: 100px;\n\t}\n\t.activityCounterSection {\n\t\twidth: 130px;\n\t\ta {\n\t\t\tmargin: 0 4px;\n\t\t}\t\n\t}\n\t.toggleConsole,\n\t.toggleMiniMaps,\n\t.toggleSidebar {\n\t\twidth: 30px;\n\t}\n\ttd {\n\t\tpadding: 4px;\n\t\tborder-left: 1px solid $borderColor;\n\t\tvertical-align: top;\n\t\twidth: 1%;\n\t\twhite-space: nowrap;\n\t}\n\t.languageSection {\n\t\tpadding: 0;\n\t}\n\ta {\n\t\tcolor: #fff;\n\t\t//opacity: 0.6;\n\t\tline-height: 1;\n\t\t&.active,\n\t\t&:hover {\n\t\t\topacity: 1\n\t\t}\n\t}\n\t.languageSection {\n\t\ttext-align: right;\n\t}\n\tsvg {\n\t\tmin-width: $baseIconFontSize;\n\t\tmin-height: $baseIconFontSize;\n\t}\n}\n\n// responsive \n\n@media (max-width: 959px) {\n\t.fms-footer {\n\t\t.activityCounterSection {\n\t\t\twidth: auto;\n\t\t}\n\t}\n}\n@media (max-width: 499px) {\n\t.toggleConsole,\n\t.toggleMiniMaps,\n\t.toggleSidebar {\n\t\tdisplay: none;\n\t}\n\t.fms-footer {\n\t\twhite-space: nowrap\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
